export default "__VITE_ASSET__CCs0h5ZA__"